import { z } from 'zod/v3';
import { CategoryFormDataSchema } from '../../classifier/schema/formData/CategoryFormDataSchema';
import { transformNull, transformNullish } from '../../common/utils';
import { ChangedBySchema } from '../../user';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { EntitySchema } from '../../common/utils/schema/EntitySchema';

export const SampleDataObjectFormDataSchema = z.object({
  id: z.number(),
  isLocked: z.boolean(),
  hasActive: z.boolean(),
  dataObjectDescriptionId: z.number(),
  comments: transformNull<string>(z.string(), ''),
  statusId: z.number().nullable(),
  dataModifiedBy: ChangedBySchema.nullable(),
  dataModifiedAt: zIsoDateTime().nullable(),
});

const SampleDataSubjectFieldsSchema = EntitySchema.extend({
  valueDate: z.string().nullable(),
  statusId: z.number().nullable(),
  isLocked: transformNull<boolean>(z.boolean(), false),
  dataSubject: z
    .object({
      id: z.number(),
      name: transformNull<string>(z.string(), ''),
      code: transformNull<string>(z.string(), ''),
      legalForm: CategoryFormDataSchema.nullable(),
    })
    .nullable(),
  dataManager: ChangedBySchema.nullable(),
  dataModifiedBy: ChangedBySchema.nullable(),
  dataModifiedAt: zIsoDateTime().nullable(),
  comments: transformNull<string>(z.string(), ''),
  sampleDataObjects: z.array(SampleDataObjectFormDataSchema),
});

const transformDataSubject = <
  T extends Omit<z.infer<typeof SampleDataSubjectFieldsSchema>, 'id'>,
>({
  dataSubject,
  ...rest
}: T) => ({
  dataSubject: {
    id: dataSubject?.id || 0,
    code: dataSubject?.code,
    name: dataSubject
      ? (`${dataSubject.code} - ${dataSubject.name}` as const)
      : ('' as `${string} - ${string}`),
  },
  legalForm: dataSubject?.legalForm?.name || '',
  ...rest,
});

export const SampleDataSubjectFormDataSchema =
  SampleDataSubjectFieldsSchema.extend({
    id: transformNullish<number>(z.number(), 0),
  }).transform(transformDataSubject);

export const SampleFormDataSchema = z.object({
  samples: SampleDataSubjectFormDataSchema.array(),
});
